// extracted by mini-css-extract-plugin
export default {"topsection":"tandC_topsection__hbs0O","main":"tandC_main__Sq60n","mainsection":"tandC_mainsection__gYYoU","subheading":"tandC_subheading__vBiT1","mail":"tandC_mail__LA-RX"};